import React, { useEffect, useState } from 'react';
import { formatAmountForInput } from '../../../../utils/Utils';
import LoadingSpinner from '../../../spinners/LoadingSpinner'
import CardBalanceDepositar from '../../../../components/card/CardBalanceDepositar'


import CopyNotification from '../../../banners/CopyNotification'
import ModalAlert from '../../../modal/ModalAlert'
import { motion } from 'framer-motion';
import SearchableSelect from '../../../select/SearchableSelect';
import InputLogin from '../../../inputs/InputLogin';
import UploadImage from '../../../inputs/UploadImage'
import { copyToClipboard } from '../../../../utils/Utils'
import ColorsMain from '../../../../colors/ColorsMain';
import CardCustom from '../../../card/CardCustom';

import Bank from '../../../../assets/IconsColurs/IconsGeneral/bank.svg'

import { ReactComponent as COPY } from '../../../../assets/IconsColurs/IconsGeneral/copy.svg';
import { ReactComponent as Hours } from '../../../../assets/IconsColurs/IconsGeneral/hourglass.svg';

const TransfertBanck = ({
    setBank,
    bank,
    BankList,
    voucherBanck,
    setBack,
    currency,
    currencyList,
    listBanck,
    setCurrency,
    listCurrency,
    montoTransfert,
    setMontoTransfert,
    setEvidencia,
    evidencia,
    closeTransfert,
    setCloseTransfert,
    finishTransfert,
    setVoucherBanck,
    closeModalTransfert,
    OnclosePrevBanck,

    modalVariants,
    banckError,
    currencyError,
    montoTransfertError,
    evidenciaError,
    selectBanck,
    selectBanckError,
    errorMessage,
    banckArray,
    loadingBank,
    errorMessageBank,
    walletCop,
    setLoadingBank


}) => {


    const [show, setShow] = useState(false)

    const CopyNumAcount = () => {
        copyToClipboard(foundBank.account_number, setShow);
    };
    const CopyNit = () => {
        copyToClipboard(foundBank.identification_number, setShow);
    };

    // Animación de contenedor
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2, // Espaciado entre animaciones de hijos
            },
        },
    };

    // Animación de elementos
    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
    };

    // Filtra la lista de monedas según el estado de walletCop
    const filteredCurrencyList = walletCop
        ? currencyList.filter((currency) => currency.code === "COP")
        : currencyList.filter((currency) => currency.code === "USD");

    const foundBank = Array.isArray(banckArray) ? banckArray.find((item) => item.id === bank) : null;

    return (
        <>
            <CopyNotification show={show} />
            <div className='w-full h-auto  mb-6 flex flex-col justify-center' >

                {loadingBank && <LoadingSpinner />}
                {!voucherBanck && !loadingBank && banckArray && <>
                    <p className='text-[16px] text-start mb-6 font-normal traking-[-0.14px] leading-[18px] '>
                        {walletCop ? 'Selecciona el banco al cual quieres transferir:' : 'Selecciona el banco al cual quieres transferir:'}
                    </p>
                    {/* SELECT BANCK */}
                    {/*    <div className='w-full h-[7vh]  '>
                    <div className='w-full h-[45px] flex flex-row gap-2 justify-between items-start ' >
                        <p className='text-base text-[#B7B7B9] text-' >Banco destino</p>
                        <div className='w-[65%] flex flex-col justify-between gap-1 ' >
                            <SearchableSelect setSelectOpcion={setBank} list={listBanck} error={selectBanckError} />
                            <p className='text-start' style={{ color: `${ColorsMain.errorBorder}` }} >{errorMessageBank} </p>

                        </div>
                    </div>
                </div> */}

                    <div className="w-full h-auto pb-2 gap-2 flex flex-row">
                        {banckArray

                            .map((bank) => (
                                <CardCustom
                                    key={bank.id}
                                    label={bank.bank_name_display === 'Banco BBVA Colombia S.A.' ? 'Banco BBVA' : bank.bank_name_display}
                                    balance={bank.account_type_display}
                                    onClick={() => setBank(bank.id)}
                                    hover={false}
                                    isSelect={bank?.id === foundBank?.id}
                                />
                            ))}


                    </div>


                    {bank && foundBank && (
                        <motion.div
                            className="w-full h- bg-[#5E5E6329] rounded-[12px] flex flex-col p-5 gap-5"
                            variants={containerVariants}
                            initial="hidden"
                            animate="visible"
                        >
                            <motion.div className="w-full h-auto flex flex-row justify-between" variants={itemVariants}>
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">
                                    Banco
                                </p>
                                <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                    {foundBank.bank_name_display}
                                </p>
                            </motion.div>
                            <motion.div className="w-full h-auto flex flex-row justify-between" variants={itemVariants}>
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">
                                    Tipo de cuenta
                                </p>
                                <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                    {foundBank.account_type_display}
                                </p>
                            </motion.div>
                            <motion.div
                                className="w-full h-auto flex flex-row justify-between"
                                onClick={CopyNumAcount}
                                variants={itemVariants}
                            >
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">
                                    Número de cuenta
                                </p>
                                <div className="flex flex-row gap-2 cursor-pointer">
                                    <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                        {foundBank.account_number}
                                    </p>
                                    <COPY />
                                </div>
                            </motion.div>
                            <motion.div className="w-full h-auto flex flex-row justify-between" variants={itemVariants}>
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">Nombre</p>
                                <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                    {foundBank.account_name}
                                </p>
                            </motion.div>
                            {currency === "COP" && <motion.div
                                className="w-full h-auto flex flex-row justify-between"
                                onClick={CopyNit}
                                variants={itemVariants}
                            >
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">NIT</p>
                                <div className="flex flex-row gap-2 cursor-pointer">
                                    <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                        {foundBank.identification_number}
                                    </p>
                                    <COPY />
                                </div>
                            </motion.div>}
                            {currency === "USD" && <motion.div
                                className="w-full h-auto flex flex-row justify-between"
                                onClick={CopyNit}
                                variants={itemVariants}
                            >
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">Routing Number</p>
                                <div className="flex flex-row gap-2 cursor-pointer">
                                    <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                        {foundBank.routing_number}
                                    </p>
                                    <COPY />
                                </div>
                            </motion.div>}
                            {currency === "USD" && <motion.div
                                className="w-full h-auto flex flex-row justify-between"
                                onClick={CopyNit}
                                variants={itemVariants}
                            >
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">Address</p>
                                <div className="flex flex-row gap-2 cursor-pointer">
                                    <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                        {foundBank.address}
                                    </p>
                                    <COPY />
                                </div>
                            </motion.div>}
                            {currency === "USD" && <motion.div
                                className="w-full h-auto flex flex-row justify-between"
                                onClick={CopyNit}
                                variants={itemVariants}
                            >
                                <p className="text-[16px] font-normal tracking-[-0.14px] leading-[18px] text-[#B7B7B9]">Wire</p>
                                <div className="flex flex-row gap-2 cursor-pointer">
                                    <p className="text-[16px] font-bold tracking-[-0.14px] leading-[18px] text-[#ffffff]">
                                        {foundBank.wire}
                                    </p>
                                    <COPY />
                                </div>
                            </motion.div>}
                        </motion.div>
                    )}
                </>}
                {voucherBanck && !loadingBank && <>
                    <div className='w-full h-[30vh]  flex flex-col ' >
                        <p className='text-[16px] text-start mb-6 font-normal traking-[-0.14px] leading-[18px] '>
                            {`Envía la cantidad de dinero que quieres cargar en ${currency} a la siguiente cuenta bancaria:`}
                        </p>
                        <div className='w-full h-[100%] flex flex-col gap-2 py-2 ' >
                            <div className='w-full h-[45px] flex flex-row gap-2 justify-between items-start ' >
                                <p className='text-base text-[#B7B7B9] text-' >Banco destino</p>
                                <div className='w-[67%]' >
                                    <SearchableSelect setSelectOpcion={setBack} list={BankList} error={banckError} />
                                </div>
                            </div>
                            <div className='w-full h-[45px] flex flex-row gap-2 justify-between items-start ' >
                                <p className='text-base text-[#B7B7B9] text-' >Moneda</p>
                                <div className='w-[67%]' >
                                    <SearchableSelect setSelectOpcion={setCurrency} list={filteredCurrencyList} error={currencyError} />
                                </div>
                            </div>
                            <div className='w-full h-[45px] flex flex-row gap-2 justify-between items-start ' >
                                <p className='text-base text-[#B7B7B9] text-' >Monto Tranferido</p>
                                <div className='w-[67%]' >
                                    <InputLogin
                                        placeholder="$0.00"
                                        value={montoTransfert}
                                        onChange={(e) => setMontoTransfert(e)}
                                        error={montoTransfertError}
                                        numericOnly={true}
                                        formatValue={(value) => formatAmountForInput(value, ',')} // Formato con separador de miles
                                    />
                                </div>
                            </div>
                            <div className='w-full h-[50px] flex flex-row gap-2 justify-between items-start ' >
                                <p className='text-base text-[#B7B7B9] text-' >Cargar evidencia</p>
                                <div className='w-[67%] h-full  ' >
                                    <UploadImage setValue={setEvidencia} value={evidencia} error={evidenciaError} />
                                    <p className='text-[14px] text-start mt-1 text-[#e4847f]'  >{errorMessage}</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    {closeTransfert &&
                        <motion.div
                            className="bg-[#26262D] "
                            variants={modalVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            transition={{ duration: 0.5, ease: "easeOut" }}>
                            <ModalAlert onClickBack={() => setCloseTransfert(false)} onClick={closeModalTransfert} className={`text-start`} title='¿Estás seguro que quieres salir?' description='Si abandonas ahora, perderás el progreso de esta transacción y deberás comenzar de nuevo.' labelButtonWhite='Salir y perder progreso' labelButtonBlack='Cancelar' />
                        </motion.div>}
                    {finishTransfert && <ModalAlert onClick={OnclosePrevBanck} icon={Hours} title='Transferencia en curso' description={`Tu transferencia está siendo revisada por nuestro equipo. En pocos minutos, tus ${currency} se verán reflejados en tu billetera`} className={`text-start`} labelButtonWhite='Entendido' />}
                </>}

                {selectBanck && <div div className="w-full h-[20px] mt-12 flex flex-row gap-2 justify-center">
                    <div
                        className={`cursor-pointer transition-all duration-300 ${!voucherBanck
                            ? 'w-8 h-3 bg-[#B7B7B9] rounded-lg'
                            : 'w-3 h-3 bg-[#1B1B22] rounded-lg'
                            }`}
                        onClick={() => setVoucherBanck(false)}
                    ></div>
                    <div
                        className={`cursor-pointer transition-all duration-300 ${voucherBanck
                            ? 'w-8 h-3 bg-[#B7B7B9] rounded-lg'
                            : 'w-3 h-3 bg-[#1B1B22] rounded-lg'
                            }`}
                        onClick={() => setVoucherBanck(true)}
                    ></div>
                </div>}

            </div >
        </>
    );
};

export default TransfertBanck;
